<template>
  <div>
    <el-form ref="cancelForm" :model="cancelForm" :rules="cancelRulers">
      <el-form-item prop="cancelReason" label=" " label-width="15px">
        <el-input
          :rows="3"
          resize="none"
          type="textarea"
          maxlength="300"
          class="cancelInput"
          v-model="cancelForm.cancelReason"
          placeholder="300字以内"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "CancelForm",
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cancelForm: {
        status: 3,
        cancelReason: '',
      },
      cancelRulers: {
        cancelReason: [{ required: true, message: '请输入取消原因', trigger: 'blur' }],
      },
    }
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['cancelForm'].validate(async (valid) => {
          if (valid) {
              resolve({ id: this.data.id, ...this.cancelForm })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="less">
@import '../../../../assets/form.less';
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
</style>
